import { app } from 'app/app';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { AppController } from 'app/controller';
import { MasterLayout } from 'layout/master/main';
import { ArticleCardSlider } from 'module/articleCardSlider/main';
import { SalaryBenchmarkForm } from 'module/salaryBenchmarkForm/main';
import { JobsListPlain } from 'module/jobsListPlain/main';
import 'module/hero/main';
import 'module/averageSalaryRangeBox/main';
import 'module/similarJobSalaries/main';
import 'module/hr/main';
import 'module/salaryProposalList/main';
import { smoothScrollToElement } from 'util/scroll';
import { buildUrl } from 'util/url';

import './styles.scss';

class SalaryBenchmarkLandingPage extends AppController {
    domBindings() {
        return {
            articleCardSlider: '.c-salaryBenchmarkLandingPage__blogSliderWrapper .m-articleCardSlider',
            jobsList: '.c-salaryBenchmarkLandingPage__jobsList .m-jobsListPlain',
            formContainer: '.c-salaryBenchmarkLandingPage__salaryBenchmarkForm',
            rangeBoxButton: '.m-averageSalaryRangeBox__personalizeButton',
            component: '.c-salaryBenchmarkLandingPage',
            salaryBenchmarkForm: '.m-salaryBenchmarkForm',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.articleCardSlider = new ArticleCardSlider(this.dom.articleCardSlider);
        if (this.dom.jobsList) this.jobsList = new JobsListPlain(this.dom.jobsList);
        this.salaryBenchmarkForm = new SalaryBenchmarkForm(this.dom.salaryBenchmarkForm);
        this.detectPreservedFormData();
    }

    subEvents() {
        this.jobsList.events.on(
            'changedLocation',
            (searchRequest) => {
                window.location.href = buildUrl(`/jobs/${searchRequest.arguments[0].locationSlug}`);
            },
        );
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true);
            });
        }
    }

    scrollToForm(e) {
        if (e) e.preventDefault();
        setTimeout(smoothScrollToElement(this.dom.formContainer, 1000, -20), 1500);
    }

    detectPreservedFormData() {
        if (this.dom.component.classList.contains('c-salaryBenchmarkLandingPage--showFormular')) {
            setTimeout(smoothScrollToElement(this.dom.formContainer, 1000, -20), 1500);
        }
    }
}

app.boot(SalaryBenchmarkLandingPage);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(SalaryBenchmarkLandingPage);
    });

    module.hot.accept(() => {});
}
